<div class="lesson-nav">
    <div class="course-title">
        <h3>Знакомство с HTML и CSS</h3>
        <div class="course-progress">
            {{CompetedLessons(navData)}}/{{navData.length}}
        </div>
    </div>
    <div class="course-nav">
        <a class="nav-block" *ngFor="let block of navData" [routerLink]="['/theory', block.id]">
            <div class="line-progress" [ngStyle]="{'width.%': (block.tp/block.tt)*100}">
                <span class="lesson-name">{{block.nm}}</span>
            </div>
        </a>
    </div>
</div>
<ng-container  *ngIf="lesson_theory !== null; else loading">
<div class="block-page-title">
    <h2 class="page-title">{{lesson_theory.name}}</h2>
    <div class="course-progress">

        <circle-progress
            [radius]="50"
            [percent] = "CurrentLessonPercent(navData)"
            [maxPercent] = "100"
            [unitsFontSize]="'24px'"
            [titleFontSize]="'24px'"
            [outerStrokeColor]="'#7D17FF'"
            [unitsColor]="'#000000'"
            [titleColor]="'#000000'"
            [unitsFontWeight]="'bold'"
            [titleFontWeight]="'bold'"
            [animationDuration]="0"
            [outerStrokeWidth]="6"
            [space]="-6"
            [showBackground]="false"
            [showInnerStroke]="true"
            [innerStrokeColor] = "'rgba(125, 23, 255, 0.07)'"
            [showSubtitle]="false"
            [clockwise]="false">
        </circle-progress>

    </div>
</div>
<div class="lesson-info">
    <div class="lesson-theory">
        {{lesson_theory.theory}}
    </div>
    <div class="lesson-figure" *ngIf="lesson_theory.img">
        <div class="col-8">
            <img src="assets/img/default/rectangle.png" alt="">
        </div>
    </div>
    <div class="lesson-buttons">
        <div *ngIf="PrevLesson(navData)" [routerLink]="['/theory', PrevLesson(navData)]" class="prev-lesson button-purple-light-nofill">
            Предыдущий урок
        </div>
        <div *ngIf="NextLesson(navData)" [routerLink]="['/theory', NextLesson(navData)]" class="next-lesson button-purple-light-fill">
            Следующий урок
        </div>
    </div>
    <div class="task-link">
        <a href="#">Перейти к домашнему заданию</a>
    </div>
    <div class="lesson-more" *ngIf="lesson_theory.homework || lesson_theory.materials">
        <div class="col-8" ngIf="lesson_theory.homework">
            <div class="lesson-homework">
                <h4>Домашнее задание</h4>
                <p class="homework-theory">
                    А ещё предприниматели в сети интернет набирают популярность среди определенных слоев населения, а значит, должны быть разоблачены. Каждый из нас понимает очевидную вещь: постоянный количественный рост и сфера нашей активности обеспечивает актуальность благоприятных перспектив. А также многие известные личности объективно рассмотрены соответствующими инстанциями. В своём стремлении улучшить пользовательский опыт мы упускаем, что стремящиеся вытеснить традиционное производство, нанотехнологии представляют собой не что иное, как квинтэссенцию победы маркетинга над разумом и должны быть призваны к ответу.
                </p>
            </div>
        </div>
        <div class="col-4" ngIf="lesson_theory.materials">
            <div class="lesson-materials">
                <h4>Материалы</h4>
                <div class="materials-info">
                    Начинаем готовить разметку страницы блога, разбираемся из каких тегов она состоит и за что эти теги отвечают.
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>
<ng-template #loading>Loading...</ng-template>